export default __webpack_public_path__ + "ec2a46acdf795e5774791cd175707888.svg";